// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3jJXh","header":"ClearentDisclaimer_header__3FbS2","inner":"ClearentDisclaimer_inner__3LFkC"};